import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { inmobiusJobBaseUrl, inmobiusJobApiVersion, apiKey } = CONFIG_VARS;

export const exploreApi = createApi({
  reducerPath: "exploreApi",
  baseQuery: createBaseQuery(inmobiusJobBaseUrl["1"], true), // Auth token not required
  endpoints: (builder) => ({
    getStudentsData: builder.mutation({
      query: ({ page, limit, payload }) => ({
        url: `${inmobiusJobApiVersion}/insights/students-filter`,
        method: "POST",
        body: payload,
        params: {
          page,
          limit,
          api_secret_key: apiKey || "",
        },
      }),
    }),
    exportStudentsData: builder.mutation({
      query: ({ payload }) => ({
        url: `${inmobiusJobApiVersion}/insights/students-filter/export`,
        method: "POST",
        body: payload,
        params: {
          api_secret_key: apiKey || "",
        },
      }),
    }),
  }),
});

export const { useGetStudentsDataMutation, useExportStudentsDataMutation } =
  exploreApi;
